import Photo from "../../api/types/Photo";
import normalizePhoto from "../normalizer/normalizePhoto";

type Normalized = ReturnType<typeof normalizePhoto>

export default function denormalizePhoto(normalized: Normalized, photoId: string): Photo | undefined {
    return normalized.photos[photoId];
}